import React from "react";
//#region redux
//#endregion
//#region types
import { SelfInvoiceCreateFormContainerProps } from "models/propTypes/selfInvoicePropTypes";
//#endregion
//#region components
import SelfInvoiceCreateForm from "./createForm";
import useSelfInvoiceInitialValues from "./useInitialValues";
//#endregion

const SelfInvoiceCreateFormContainer: React.FC<SelfInvoiceCreateFormContainerProps> = ({
  invoice,
  draftCustomerInvoice,
  reloadInvoice,
}) => {
  const { getInialValues } = useSelfInvoiceInitialValues(invoice, draftCustomerInvoice);
  const initialValues = getInialValues();

  return <SelfInvoiceCreateForm invoice={invoice} defaultValues={initialValues} reloadInvoice={reloadInvoice} />;
};

export default SelfInvoiceCreateFormContainer;
